import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";

const OfficesContact = () => {
  const offices = [
    {
      name: "Head Office",
      city: "Mumbai",
      address: "Kaman Road, Vasai, Maharashtra 401209",
      phone: "+91 8956622452",
      email: "dyrisfrozenfoods@gmail.com",
    },
    {
      name: "Vasai Office",
      city: "Vasai",
      address: "Vasai West, Palghar, Maharashtra 401209",
      phone: "+91 9022707285",
      email: "dzyrisvasai@gmail.com",
    },
    {
      name: "Chennai Office",
      city: "Pune",
      address: "Baner, Pune, Maharashtra 411045",
      phone: "+91 9988776655",
      email: "pune@yourcompany.com",
    },
  ];

  const [selectedOffice, setSelectedOffice] = useState(offices[0]);

  return (
    <>
      <Header />

      <div style={styles.container}>
        <h2 style={styles.title}>Offices Contact</h2>

        <div style={styles.layout}>
          {/* Sidebar */}
          <div style={styles.sidebar}>
            {offices.map((office, index) => {
              const isActive = selectedOffice.name === office.name;

              return (
                <div
                  key={index}
                  style={{
                    ...styles.officeItem,
                    ...(isActive ? styles.activeItem : {}),
                  }}
                  onClick={() => setSelectedOffice(office)}
                  onMouseEnter={(e) => {
                    if (!isActive)
                      e.currentTarget.style.background = "#fff0f5";
                  }}
                  onMouseLeave={(e) => {
                    if (!isActive)
                      e.currentTarget.style.background = "#fff";
                  }}
                >
                  <div style={styles.officeName}>{office.name}</div>
                  <div style={styles.officeCity}>{office.city}</div>
                </div>
              );
            })}
          </div>

          {/* Details */}
          <div style={styles.details}>
            <h3 style={styles.heading}>{selectedOffice.name}</h3>

            <div style={styles.infoRow}>
              <span>📍</span>
              <p>{selectedOffice.address}</p>
            </div>

            <div style={styles.infoRow}>
              <span>📞</span>
              <p>{selectedOffice.phone}</p>
            </div>

            <div style={styles.infoRow}>
              <span>✉️</span>
              <p>{selectedOffice.email}</p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

const styles = {
  container: {
    maxWidth: "1100px",
    margin: "40px auto",
    padding: "20px",
    fontFamily: "Poppins, sans-serif",
  },

  title: {
    textAlign: "center",
    fontSize: "34px",
    fontWeight: "700",
    marginBottom: "30px",
    background: "linear-gradient(90deg, #ff0051, #ff4d88)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    letterSpacing: "1px",
  },

  layout: {
    display: "flex",
    gap: "20px",
    flexWrap: "wrap",
  },

  sidebar: {
    flex: "1",
    minWidth: "260px",
    borderRadius: "14px",
    overflow: "hidden",
    boxShadow: "0 8px 25px rgba(255, 0, 81, 0.15)",
  },

  officeItem: {
    padding: "14px",
    cursor: "pointer",
    background: "#fff",
    borderBottom: "1px solid #eee",
    transition: "all 0.3s ease",
  },

  activeItem: {
    background: "linear-gradient(90deg, #ff0051, #ff4d88)",
    color: "#fff",
    transform: "scale(1.03)",
    boxShadow: "0 6px 15px rgba(255, 0, 81, 0.4)",
  },

  officeName: {
    fontWeight: "600",
    fontSize: "15px",
  },

  officeCity: {
    fontSize: "12px",
    opacity: "0.7",
  },

  details: {
    flex: "2",
    minWidth: "300px",
    padding: "28px",
    borderRadius: "16px",
    background: "rgba(255,255,255,0.75)",
    backdropFilter: "blur(12px)",
    boxShadow: "0 12px 35px rgba(255, 0, 81, 0.2)",
    transition: "all 0.4s ease",
  },

  heading: {
    fontSize: "26px",
    fontWeight: "700",
    marginBottom: "20px",
    color: "#ff0051",
  },

  infoRow: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    marginBottom: "14px",
    fontSize: "15px",
    color: "#444",
    transition: "all 0.3s ease",
  },
};

export default OfficesContact;